import { render } from "./ServicePricingGrid.vue?vue&type=template&id=2874237d&scoped=true"
import script from "./ServicePricingGrid.vue?vue&type=script&lang=js"
export * from "./ServicePricingGrid.vue?vue&type=script&lang=js"

import "./ServicePricingGrid.vue?vue&type=style&index=0&id=2874237d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2874237d"]])

export default __exports__